import React from "react";
import Spinner from "../spinner";
import "./style.scss";

interface LockOverlayProps {
    message?: string;
    showSpinner?: boolean;
}

const LockOverlay = (props: LockOverlayProps) => {
    return (
        <div className="vapor-lock-overlay">
            <div className="vapor-lock-overlay-container">
                {props.showSpinner && (
                    <div className="vapor-lock-overlay-spinner">
                        <Spinner message={props.message} />
                    </div>
                )}
            </div>
        </div>
    );
};

LockOverlay.defaultProps = {
    showSpinner: false,
};

export default LockOverlay;
